var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1302.000000, -214.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/filtro",
    transform: "translate(1285.000000, 202.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4878262,20.9599358 C22.489616,20.962611 22.4914892,20.9651999 22.4933623,20.9678319 C22.6869612,21.2375068 22.7936467,21.5718604 22.7936467,21.9091913 L22.7936467,28.2865482 C22.7936467,28.5286947 22.9092815,28.7521149 23.1030053,28.8841477 C23.2157264,28.9609079 23.3458469,29 23.4777572,29 C23.5685418,29 23.6601589,28.9814895 23.7474054,28.9440802 L26.7576167,27.754318 C27.0273065,27.6690144 27.2063366,27.4052077 27.2063366,27.0875955 L27.2063366,21.9091913 C27.2063366,21.5718604 27.313022,21.2375068 27.506621,20.9678319 C27.5084941,20.9651999 27.5103672,20.962611 27.5121571,20.9599358 L32.8689487,13.1377258 C33.0217966,12.914133 33.0424843,12.6262929 32.922895,12.3865627 C32.8039718,12.148127 32.569372,12 32.3106712,12 L17.689312,12 C17.4306113,12 17.1960115,12.148127 17.0770882,12.3865627 C16.957499,12.626336 16.9781867,12.9141761 17.1312427,13.1379847 L22.4878262,20.9599358 Z",
    id: "filter"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8695e553.svg";
export { ForwardRef as ReactComponent };